<template>
     <dialog-layout ref="businessDialog" id="businessDialog" @click="dialogActions">
        <h3 slot="headercontent" v-if="business">{{business.name}}</h3>

        <business-info-layout :business="business" />       
           
        <span v-if="!business">          
          <p>
            <font color="red">Sorry the Business details could not be found, the business has probably been removed from the system. Please contact the Business directly if you know the details or contact your FIBI administrtor.</font>
          </p>       
        </span>
        <slot :meta="meta" :business="business"></slot>        
    </dialog-layout>  

</template>

<script>
import {mapActions} from "vuex";
export default {      
  data: function() {
    return {
        business:null,
        meta:null
    };
  },
  methods: {    
    ...mapActions(['fullbusiness']),
    show({business,meta}){   
      //let clients know about      
      this.fullbusiness(business.id).then((fs)=>{
          if(fs)          
          {
            this.business = fs // || business
            this.business.id = business.id
            this.$emit('dialogActions',{action:'businessfound',data:{fs}})
          }
          else
            this.$emit('dialogActions',{action:'businessnotfound',data:{business}})         
          
          this.meta = meta
          this.$refs.businessDialog.show()      
      })        
    },
    cancelDialog(){      
        this.$refs.businessDialog.cancelDialog(this)                   
    },
    dialogActions(e) {         
      if(e.action==='canceldialog')
      {
        this.business = null
        this.meta = null       
      }        
    }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/shared/BusinessDialog.vue